module.exports = __webpack_public_path__ + "../resources/images/Social-f4f43e5edb76b69e39d0f5d2c6c6ee77.svg";